import { render, staticRenderFns } from "./recordProject.vue?vue&type=template&id=1b93b699&"
import script from "./recordProject.vue?vue&type=script&lang=js&"
export * from "./recordProject.vue?vue&type=script&lang=js&"
import style0 from "./recordProject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports